var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEatsure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_20612)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 1.12,
    fill: "#4035DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9802 35.7594V41.0745H25.5111H5.60001V14.5601H25.5111H26.9802V22.0644H18.1537V24.0955H26.9802V33.7283C26.1789 33.6796 25.3654 33.5823 24.5398 33.4485C21.019 32.8647 18.6272 31.6728 18.6029 31.6606L17.6924 33.4729C17.8016 33.5215 20.3391 34.7986 24.1392 35.431C25.0862 35.6013 26.0453 35.6986 26.9802 35.7594ZM41.5371 24.0955V22.0644H50.4V14.5601H29.0077V33.7648C31.9822 33.6796 34.7868 32.9864 37.3728 31.6606L38.2834 33.4729C35.4424 34.908 32.2979 35.6865 28.9956 35.7838V41.0745H50.4V24.0955H41.5371Z",
    fill: "#39D723"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_20612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatsure);
export default __webpack_public_path__ + "static/media/eatsure.4306b70c79dac609333bc67169ce3f44.svg";
export { ForwardRef as ReactComponent };